import goalSettingsStepsSchema from './GoalSettings/stepsSchema';
import dietSettingsStepsSchema from './DietSettings/stepsSchema';
import biometricSettingsStepsSchema from './BiometricSettings/stepsSchema';
import mealPlanSettingsStepsSchema from './MealPlanSettings/stepsSchema';
import packageJson from '../package.json';
export const ALLOWED_LANGUAGES = ['pl-PL', 'en-US'];

export const SENTRY_DSN = ''; // TODO: add SENTRY_DSN

export const APP_STORE_URL =
  'https://apps.apple.com/pl/app/maxxnation-plany-treningowe/id1546994529?l=pl';
export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.maxxnation.workout_for_men&hl=pl';

export const APP_VERSION = packageJson.version;
export const APP_BRAND = 'maxx';

export const SLIDE_ROUTES_DURATION = 350;

export const LANDING_URL = 'https://maxxnation.pl/';

export const siteMetadata = {
  lang: 'en',
  shortName: 'MAXXnation',
  name: 'MAXXnation',
  themeColor: '#ffffff',
  title: 'MAXXnation',
  description: 'Treningi i Prosta Dieta',
  keywords: ['MAXXnation'],
  author: 'activerse.app',
};

export const FRISCO = true;
export const FRISCO_FIREBASE_FUNCTION = '';
export const FRISCO_PARTNER = 'MAXX';
export const FRISCO_DESKROP_URL_PL = 'https://maxxnation.com/frisco/';
export const FRISCO_DESKROP_URL_EN = 'https://maxxnation.com/frisco/';

export const INSTACART_FIREBASE_FUNCTION = '';
export const INSTACART_URL = 'https://www.instacart.com/store/partner_recipes';

export const FIRST_DIET_SETTINGS_STEP_SLUG = dietSettingsStepsSchema[0].slug;
export const FIRST_GOAL_SETTINGS_STEP_SLUG = goalSettingsStepsSchema[0].slug;
export const FIRST_BIOMETRIC_SETTINGS_STEP_SLUG = biometricSettingsStepsSchema[0].slug;
export const FIRST_MEAL_PLAN_SETTINGS_STEP_SLUG = mealPlanSettingsStepsSchema[0].slug;

export const FORCE_BUILD = false;

export const OPEN_APP_URL = ' https://get.maxxnation.app/xg6i/p90cz7lr';
